const ALPHABET = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";

/** Short correlation id: `CK-` + 6 uppercase alphanumerics (e.g. `CK-7F3A2B`). */
export function generateErrorId(): string {
  let out = "CK-";
  for (let i = 0; i < 6; i++) {
    out += ALPHABET[Math.floor(Math.random() * ALPHABET.length)] ?? "0";
  }
  return out;
}

const ERROR_ID_RE = /^CK-[A-Z0-9]{6}$/;

export function isErrorId(value: string): boolean {
  return ERROR_ID_RE.test(value);
}
